"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Grid_1 = tslib_1.__importDefault(require("@mui/material/Grid"));
const Paper_1 = tslib_1.__importDefault(require("@mui/material/Paper"));
const getStyles = () => ({
    card: {
        borderColor: "rgba(0,0,0,0.12)",
        borderStyle: "solid",
        borderWidth: "1px",
        maxWidth: 704,
        paddingTop: (theme) => theme.spacing(2),
    },
});
/**
 *
 * @category component
 */
const CardError = ({ children, paperProps = {} }) => {
    const styles = getStyles();
    return (react_1.default.createElement(Grid_1.default, { container: true, justifyContent: "center", sx: { mt: 3 } },
        react_1.default.createElement(Grid_1.default, { item: true },
            react_1.default.createElement(Paper_1.default, { ...{ square: true, elevation: 0, sx: styles.card, ...paperProps } }, children))));
};
exports.default = CardError;
